import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ItemCode from './ItemCode';
import './CodeInput.scss';

const CodeInput = ({ getCode, lengthItems }) => {
    const [isEnd, setIsEnd] = useState(false);
    const [code, setCode] = useState(['', '', '', '', '', '']);

    const updateCode = (currentValue, index) => {
        if (currentValue.length < 2) {
            const newValue = code.slice();
            newValue[index] = currentValue;
            setCode(newValue);
        }

        setIsEnd(index === lengthItems - 1);
    };

    useEffect(() => getCode(code, isEnd), [code]);

    return (
        <div className='code-input'>
            {code.map((value, index) =>
                <ItemCode key={index} index={index} value={value} updateCode={updateCode} />)}
        </div>
    );
};

export default CodeInput;

CodeInput.propTypes = {
    getCode: PropTypes.func,
    lengthItems: PropTypes.number
};

CodeInput.defaultProps = {
    lengthItems: 6
};